import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { ComponentProps, ElementType } from "react";

const PREFIX = "OffersChip";
export const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  icon: `${PREFIX}-icon`,
  label: `${PREFIX}-label`,
};

export const ChipStyled = styled(Chip)<{ component?: ElementType } & ComponentProps<"a">>(({ theme }) => ({
  [`&.${classes.root}`]: {
    color: theme.palette.background.paper,
    padding: theme.spacing(0.5),
    cursor: "pointer",
    [`& .${classes.content}`]: {
      flexDirection: "row",
      alignItems: "center",
      gap: theme.spacing(1),
      [`> svg, span`]: {
        color: "white !important",
      },
      [`& .${classes.icon}`]: {
        width: 18,
        height: 18,
      },
      [`& .${classes.label}`]: {
        textDecoration: "underline",
      },
    },
  },
}));
